import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import Tooltip from '@atlaskit/tooltip';
import { getATLContextUrl } from '@atlassian/atl-context';

import { useEditionAwareness } from '../../services/edition-awareness-context';
import { EditionAwarenessLink } from '../edition-awareness-button';

export const ServiceCollectionLink = (): React.JSX.Element => {
	const { cloudId, orgId } = useEditionAwareness();
	const adminHubUrl = getATLContextUrl('admin');

	const href = `${adminHubUrl}/o/${orgId}/atlassian-apps?openServCoUpgradeDrawer=true&defaultSiteId=${cloudId}&redirectedFrom=topNavEAPill`;

	return (
		<Tooltip
			content={
				<FormattedMessage
					id="@atlassian/edition-awareness.link.service-collection-tooltip"
					defaultMessage="Try Service Collection"
					description="Tooltip for Service Collection upgrade link"
				/>
			}
			position="bottom"
		>
			<EditionAwarenessLink
				href={href}
				target="_blank"
				touchpointIntent="startTrial"
				linkId="service-collection-uplift"
			/>
		</Tooltip>
	);
};
